import { Component, OnInit } from '@angular/core';
import { Utils } from 'src/app/common/services/utils.service';
import { ShuttleRouteMasterService } from '../shuttle-route-master/shuttle-route-master.service';
import { HttpRequestService } from 'src/app/common/services/http-request.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-trip-cancel',
  templateUrl: './trip-cancel.component.html',
  styleUrls: ['./trip-cancel.component.css']
})
export class TripCancelComponent implements OnInit {
  comboSource: any[];
  cancelReasonTemplate: any[];
  cancelReasonConfig: object;

  constructor(public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private utils: Utils,
    private httpService: HttpRequestService,
    private shuttleRouteMasterService: ShuttleRouteMasterService) { }

  fetchReasonDetails() {
    let formTemplate, formConfig;
    if (this.config.data.isFromQr) {
      formTemplate = this.shuttleRouteMasterService.getCancelReasonTemplateForQuickResponse();
      formConfig = this.shuttleRouteMasterService.cancelFormConfiginQr;
    } else {
      formTemplate = this.shuttleRouteMasterService.getCancelReasonTemplate();
      formConfig = this.shuttleRouteMasterService.cancelFormConfig;
    }
    this.cancelReasonTemplate = formTemplate;

    formConfig['formGroup'] = this.utils.constructFormControlGroup(formTemplate, null, this.comboSource);
    this.cancelReasonConfig = formConfig;
    this.utils.mapArrayToFormDropdowns(this.cancelReasonTemplate, this.comboSource);
  }

  onClose() {
    this.ref.close();
  }

  OnClickWithRestore(isRestore) {
    let methodName = this.config.data.isFromQr ? 'cancelLogisticsPassReqQR' : 'cancelLogisticsPassShtTrp';
    let serviceName = this.config.data.isFromQr ? 'CoreRequestService' : 'PPLCorePassengerLogistics';
    let reqData, reqConfigs;
    if (this.config.data.isFromQr) {
      reqConfigs = this.config.data.reqData[0].PassengerReqTrip_array[0];
      reqData = {
        'PassengerReqTrip_array': this.utils.insertIdFieldInDataSource([this.config.data.reqData[0].PassengerReqTrip_array[0]], 'I')
      };
      reqConfigs['CANCEL_REASON'] = this.cancelReasonConfig['formGroup'].controls.strCrtReqReason.value.id;
    } else {
      reqConfigs = this.config.data.reqData[0].PassengerShtTrip_array[0];
      reqData = {
        'strScheduleNo': this.config.data.reqData[0]['strScheduleNo'],
        'strShuttleNo': reqConfigs.PPL_SHUTTLE_NO,
        'PassengerShtTrip_array': this.utils.insertIdFieldInDataSource([this.config.data.reqData[0].PassengerShtTrip_array[0]], 'I')
      };
      reqConfigs['CANCEL_REASON'] = this.cancelReasonConfig['formGroup'].controls.strRejectComment.value.id;
    }
    reqConfigs['CANCEL_FLAG'] = isRestore;
    const requestData = this.utils.constructRequestData(reqData, serviceName, methodName);
    this.httpService.configRequestDataWithHeaders(requestData, 'post', '')
      .subscribe((response: any) => {
        this.ref.close(response);
      });
  }

  ngOnInit() {
    this.comboSource = this.config.data['comboSource'];
    this.fetchReasonDetails();
  }
}
